import { html } from "lit-html"
import { virtual } from "haunted"
import { parseDate } from "../utils"
import { unsafeHTML } from "lit-html/directives/unsafe-html"
import { DOC_ICON_MAP } from "../constants"

const DocumentRow = virtual(
  ({ name, category, url, agency, date, created_at, highlight }) => {
    const dateObj = parseDate(date || created_at)
    const dateStr = dateObj.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    })

    let agencyStr = ``
    if (typeof agency === "string") {
      agencyStr = agency
    } else if (agency && agency.name) {
      agencyStr = agency.name
    }

    return html`
      <div
        class="document-row min-h-13 p-3 pb-0 relative flex flex-row flex-wrap"
      >
        <div class="w-full lg:w-1/2 order-1 flex flex-row items-center p-3">
          <div
            class="min-w-32 w-9 h-10 bg-yellow text-black flex flex-row items-center justify-center text-sm"
          >
            <i
              class=${category in DOC_ICON_MAP
                ? DOC_ICON_MAP[category]
                : "fas fa-file"}
            ></i>
          </div>
          <div class="ml-5">
            <p>
              <a href=${url}>${name}</a>
            </p>
            <p>${agencyStr}</p>
          </div>
        </div>
        <div class="w-2/3 lg:w-1/3 order-3 lg:order-2 p-3 pl-50px lg:pl-3">
          <p>${dateStr}</p>
        </div>
        <div
          class="w-1/4 lg:w-1/6 flex-grow order-4 lg:order-3 p-3 text-right lg:text-left"
        >
          <p>${category.includes("Google") ? "Notes" : category}</p>
        </div>
        ${highlight
          ? html`
              <div class="p-3 order-5 lg:order-4">
                <div
                  class="search-highlights border-l-6 border-gray-200 mb-6 pl-5"
                >
                  <p>...${unsafeHTML(highlight)}...</p>
                </div>
              </div>
            `
          : ``}
        <hr class="divider m-3 mb-0 order-10" />
      </div>
    `
  }
)

export default DocumentRow
